class AuthManager {
  loginHandler(loginData) {
    const {token, userInfo, expiration} = loginData;
    localStorage.setItem('token', token);
    localStorage.setItem('expiration', expiration);
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  logoutHandler() {
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('lastClicked');
    localStorage.removeItem('defaultItem');
    window.location.href = '/login';
  }

  async isLogin() {
    const token = await localStorage.getItem('token');

    if (token) {
      return true;
    } else {
      return false;
    }
  }
}

const authManager = new AuthManager();
export default authManager;

